import { type HierarchicalLogger } from '@atlassian/logger-interface';
import type { TcsSidecarApi, LicenseInformation } from '@post-office/tcs-client';

export const getProductsFromTcs = async ({
	messageTemplateId,
	siteId,
	tcsClient,
	logger,
}: {
	messageTemplateId: string;
	siteId: string | undefined;
	tcsClient: TcsSidecarApi | undefined;
	logger: HierarchicalLogger | undefined;
}): Promise<{
	hasJira: boolean;
	hasConfluence: boolean;
	hasLoom: boolean;
	hasRovo: boolean;
	hostname: string;
}> => {
	try {
		logger?.info({ siteId, messageTemplateId }, 'Getting products from TCS');

		const tcsResponse = await tcsClient?.cloud?.getTcsRecord<LicenseInformation>(
			`${siteId}.xflow.license.information`,
		);

		if (!tcsResponse || !tcsResponse.data) {
			logger?.error({ siteId, messageTemplateId }, 'No license information found for siteId');
			throw new Error(`No license information found for siteId: ${siteId}`);
		}

		const products = tcsResponse.data.products;
		const hasJira = products['jira-software.ondemand']?.state === 'ACTIVE';
		const hasConfluence = products['confluence.ondemand']?.state === 'ACTIVE';
		const hasLoom = products['loom']?.state === 'ACTIVE';
		const hasRovo = products['rovo.ondemand']?.state === 'ACTIVE';

		return {
			hasJira,
			hasConfluence,
			hasLoom,
			hasRovo,
			hostname: tcsResponse.data.hostname,
		};
	} catch (error) {
		logger?.error(
			{ error, siteId, messageTemplateId },
			'Error retrieving license information from TCS',
		);
		throw error;
	}
};
